import {
  APP_INITIALIZER,
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { routes } from './app.routes';
import { provideAppConfig } from './core/config/providers';
import { provideCoreHttp } from './core/http/provide-http';
import { runtimeConfig } from './core/config/runtime-config';
import { AppConfig } from './core/config/app-config.token';
import { NAV_SECTIONS } from './shared/nav/nav-sections.token';
import { NavSection } from './shared/nav/nav-section.model';
import { NavIcons } from './shared/nav/nav-icons';

async function loadRuntimeConfig(): Promise<void> {
  try {
    const res = await fetch('/config.json');
    if (!res.ok) return;
    const json: Partial<AppConfig> = await res.json();
    Object.assign(runtimeConfig, json);
  } catch {
    // config.json ausente o red caída — se usan los valores compilados
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: APP_INITIALIZER, useFactory: () => loadRuntimeConfig, multi: true },
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      }),
    ),
    ...provideAppConfig(),
    ...provideCoreHttp(runtimeConfig.apiBaseUrl, []),

    // ── Tipo de usuario: Afiliado ────────────────────────────────────────
    // Sección principal del portal. "Mis Datos" hace drill-down en el sidebar.
    {
      provide: NAV_SECTIONS,
      useValue: {
        title: 'Afiliado',
        items: [
          {
            label: 'Inicio',
            route: '/',
            icon: NavIcons.home,
          },
          {
            label: 'Mis Datos',
            icon: NavIcons.person,
            drillTitle: 'Mis datos',
            children: [
              { label: 'Datos de contacto', route: '/perfil/contacto',      icon: NavIcons.contact  },
              { label: 'Empleadores',        route: '/perfil/empleadores',   icon: NavIcons.building },
              { label: 'Cuenta bancaria',    route: '/perfil/cuenta',        icon: NavIcons.bank     },
              { label: 'Autorizaciones',     route: '/perfil/autorizaciones',icon: NavIcons.shield   },
            ],
          },
        ],
      } satisfies NavSection,
      multi: true,
    },

    // ── Tipo de usuario: Empresa empleadora ──────────────────────────────
    // Acceso directo al listado de trabajadores.
    {
      provide: NAV_SECTIONS,
      useValue: {
        title: 'Empresa',
        items: [
          {
            label: 'Mis trabajadores',
            route: '/empresa/trabajadores',
            icon: NavIcons.users,
          },
        ],
      } satisfies NavSection,
      multi: true,
    },
  ],
};
